import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validateEmailSearch: Validator = (data: SearchContextType) => {
  const { emailAddress, firstName, middleNames, lastName, dateOfBirth } = data;

  const hasEmail = !!emailAddress?.trim();
  const hasAnyOtherValue =
    !!firstName?.trim() ||
    !!middleNames?.trim() ||
    !!lastName?.trim() ||
    !!dateOfBirth?.toString().trim();

  const isEmailOnlySearch = hasEmail && !hasAnyOtherValue;

  if (!hasEmail) {
    return { isValid: false, errors: [] };
  }

  return isEmailOnlySearch
    ? { isValid: true, errors: [] }
    : { isValid: false, errors: [ValidationErrorMessages.invalidEmail] };
};

export default validateEmailSearch;
